// util.js

/**
 * Returns the number of months from the given month-year to the current date.
 * @param {string} submittedDate - The submitted date in 'MMM YYYY' format, e.g., 'Feb 2024'.
 * @returns {number} - The number of months between the given date and the current date.
 */
export function monthsFromSubmittedDate(submittedDate) {
    if (!submittedDate) {
      throw new Error("Submitted date is required");
    }
  
    // Parse the submitted date
    const [monthStr, yearStr] = submittedDate.split(' ');
    const year = parseInt(yearStr, 10);
    const month = new Date(Date.parse(`${monthStr} 1, 2022`)).getMonth(); // Using 2022 to extract month index
  
    if (isNaN(year) || isNaN(month)) {
      throw new Error("Invalid date format");
    }
  
    // Create Date objects for comparison
    const submittedDateObj = new Date(year, month);
    const today = new Date();
  
    // Calculate the difference in months
    let months = (today.getFullYear() - submittedDateObj.getFullYear()) * 12;
    months += today.getMonth() - submittedDateObj.getMonth();
  
    return months < 0 ? 0 : months;
  }
  